// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__188ZG","range":"MonthRangeSwitch_range__2egcC","disabled":"MonthRangeSwitch_disabled__2S1j_"};